import React, { Component } from 'react'
import LoadingDefault from './Loading/LoadingDefault'
import {
    List,
    ListItem,
    ListItemButton,
    Button,
    ButtonGroup,
    TextField,
    Alert,
    Stack,
    IconButton,
    InputAdornment,
} from '@mui/material'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faPenAlt } from '@fortawesome/pro-duotone-svg-icons/faPenAlt'
import { faPlus } from '@fortawesome/pro-duotone-svg-icons/faPlus'
import { faSyncAlt } from '@fortawesome/pro-duotone-svg-icons/faSyncAlt'
import { faTimes } from '@fortawesome/pro-duotone-svg-icons/faTimes'
import { StyledButton } from './StyledComponents/Buttons'

export default class SelectList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            currentItem: null,
            title: this.props.title ? this.props.title : null,
            searchName: this.props.searchName ? this.props.searchName : null,
            searchVal: '',
            url: this.props.url ? this.props.url : null,
            urlParams: this.props.urlParams ? this.props.urlParams : null,
            loading: false,
            error: false,
            loadingName: false,
            page: 0,
            hasNext: false,
            limit: 10,
            items: [],
        }

        this.onKeyUp = this.onKeyUp.bind(this)
        this.updateCurrentItem = this.updateCurrentItem.bind(this)
    }

    fetchItems(fetchNext, resetSearch) {
        if (!this.state.url) {
            return
        }

        this.setState({ loading: true, error: false })
        let params = {
            params: {
                limit: this.state.limit,
                page: fetchNext ? this.state.page + 1 : this.state.page,
            },
        }

        if (
            this.state.searchName &&
            (this.state.searchVal.length > 0 || resetSearch)
        ) {
            params.params[this.state.searchName] = this.state.searchVal
            params.params.page = 0
        }

        if (this.props.urlParams) {
            params.params = Object.assign(
                {},
                params.params,
                this.props.urlParams
            )
        }

        let url = this.state.url

        this.props.kedo
            .api()
            .get(url, params)
            .then((response) => {
                this.setState({
                    loading: false,
                    items: fetchNext
                        ? [...this.state.items, ...response.data.results]
                        : response.data.results,
                    page: response.data.pager.current,
                    hasNext:
                        response.data.pager.pages > response.data.pager.current,
                })
            })
            .catch(() => {
                this.setState({ loading: false, error: true })
            })
    }

    onKeyUp(event) {
        if (!event.target.value || event.target.value === '') {
            return
        }

        if (this.state.timeout) clearTimeout(this.state.timeout)
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.timeout = setTimeout(() => {
            this.fetchItems(false)
        }, 300)
    }

    renderSearch() {
        return (
            <ListItem className={'list-group-item'}>
                <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    width="100%"
                >
                    <TextField
                        className="form-control"
                        fullWidth
                        size="small"
                        placeholder={`${this.props.kedo.t('Search')}...`}
                        value={this.state.searchVal}
                        onChange={(e) =>
                            this.setState({ searchVal: e.target.value })
                        }
                        onKeyUp={this.onKeyUp}
                        disabled={this.props.disabled}
                        slotProps={{
                            input: {
                                endAdornment: this.state.searchVal && (
                                    <InputAdornment position="end">
                                        <IconButton
                                            size="small"
                                            onClick={() =>
                                                this.setState(
                                                    {
                                                        searchVal: '',
                                                        page: 0,
                                                        items: [],
                                                    },
                                                    () =>
                                                        this.fetchItems(
                                                            false,
                                                            true
                                                        )
                                                )
                                            }
                                            sx={{
                                                color: 'grey.700',
                                                p: 0.5,
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faTimes} />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            },
                            htmlInput: {
                                'aria-describedby': 'button-addon4',
                            },
                        }}
                    />
                    {this.props.addComponent && (
                        <StyledButton
                            variant="contained"
                            startIcon={<FontAwesomeIcon icon={faPlus} />}
                            onClick={() => this.setState({ showAdd: true })}
                            disabled={this.props.disabled}
                        >
                            {this.props.kedo.t('Add')}
                        </StyledButton>
                    )}
                </Stack>
            </ListItem>
        )
    }

    renderLoadMoreAndFooter() {
        if (!this.state.hasNext) {
            return
        }

        return (
            <ListItem onClick={() => this.fetchItems(true)}>
                <i>{this.props.kedo.t('Load more')}...</i>
            </ListItem>
        )
    }

    getDisplayName(item) {
        if (this.props.onDisplayName) {
            return this.props.onDisplayName(item)
        }

        return item.name
    }

    updateCurrentItem(currentId, callBack) {
        if (!currentId || this.state.loadingName) {
            return
        }
        let [url, params] = this.props.url.split('?')

        this.setState({ loadingName: true })
        this.props.kedo
            .api()
            .get(`${url}/${currentId}${params ? '?' + params : ''}`)
            .then((response) =>
                this.setState(
                    {
                        loadingName: false,
                        currentItem: response.data,
                    },
                    callBack ? () => callBack(response.data) : null
                )
            )
    }

    componentDidMount() {
        if (!this.props.currentValue && !this.props.disableInit) {
            this.fetchItems(false)
        }

        if (this.props.currentValue && !this.state.currentItem) {
            this.updateCurrentItem(
                this.props.currentValue,
                this.props.onUpdateCurrentItem
            )
        }
    }

    getCurrentValueName() {
        return this.state.currentItem
            ? this.props.onDisplayName(this.state.currentItem)
            : this.props.currentValue
    }

    getNameLabel() {
        if (this.props.detailUrl) {
            return (
                <a
                    target={'_blank'}
                    rel={'noreferrer'}
                    href={this.props.detailUrl}
                >
                    {this.getCurrentValueName()}
                </a>
            )
        }

        return this.getCurrentValueName()
    }

    render() {
        const kedo = this.props.kedo

        if (this.props.location === 'TemplateForm') {
            return (
                <div>
                    {this.state.error ? (
                        <Alert severity={'warning'}>
                            &nbsp; {this.props.kedo.t('Something went wrong')}{' '}
                            <Button
                                sx={{ float: 'right', marginTop: '-8px' }}
                                color={'warning'}
                                onClick={() => this.fetchItems(false)}
                            >
                                <FontAwesomeIcon icon={faSyncAlt} />
                                &nbsp; {this.props.kedo.t('Retry')}
                            </Button>
                        </Alert>
                    ) : null}
                    <List>
                        {this.state.searchName ? this.renderSearch() : null}
                        {this.state.loading ? (
                            <ListItem>
                                <LoadingDefault />
                            </ListItem>
                        ) : null}
                        {this.state.items.map((item) => (
                            <ListItemButton
                                key={item.id}
                                onClick={() => {
                                    this.props.onSelect(item)
                                    this.updateCurrentItem(item.id)
                                }}
                            >
                                {this.getDisplayName(item)}
                            </ListItemButton>
                        ))}
                        {this.renderLoadMoreAndFooter()}
                    </List>
                </div>
            )
        }

        return (
            <div>
                {this.state.title ? <h2>{this.state.title}</h2> : null}
                {this.state.showAdd
                    ? this.props.addComponent(
                          (newItemId) => {
                              this.updateCurrentItem(
                                  newItemId,
                                  this.props.onSelect
                              )
                              this.setState({ showAdd: false })
                          },
                          () => this.setState({ showAdd: false })
                      )
                    : null}
                {this.state.showEdit
                    ? this.props.editComponent(() =>
                          this.setState({ showEdit: false })
                      )
                    : null}
                <ButtonGroup
                    size="small"
                    variant="outlined"
                    sx={{
                        '& .MuiButtonGroup-grouped': {
                            minWidth: 30,
                        },
                    }}
                >
                    {this.props.currentValue && this.props.editComponent ? (
                        <Button
                            title={kedo.t('Edit')}
                            sx={{ mr: 0.5 }}
                            onClick={() => this.setState({ showEdit: true })}
                        >
                            <FontAwesomeIcon icon={faPenAlt} />
                        </Button>
                    ) : null}
                    {this.props.currentValue ? (
                        <Button
                            sx={{
                                minWidth: '30px',
                                px: 1,
                                py: 0.5,
                                fontSize: '0.875rem',
                                textTransform: 'none',
                                '&.Mui-disabled': {
                                    color: 'text.primary',
                                    WebkitTextFillColor: 'currentColor',
                                },
                            }}
                            className={'badge badge-secondary inline-block'}
                            color={'secondary'}
                            disabled
                            readOnly
                        >
                            {this.getNameLabel()}
                        </Button>
                    ) : null}

                    {this.props.currentValue ? (
                        <StyledButton
                            variant="contained"
                            color="secondary"
                            dense
                            sx={{ minWidth: 30, height: 'unset', p: 0.5 }}
                            title={kedo.t('Clear')}
                            onClick={() =>
                                this.setState(
                                    { currentItem: null },
                                    this.props.onClear
                                )
                            }
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </StyledButton>
                    ) : this.props.currentValue ? (
                        <Button
                            sx={{ minWidth: '30px', p: 0.5 }}
                            className={'badge badge-secondary'}
                            onClick={this.props.onClear}
                        >
                            {this.state.loadingName ? <LoadingDefault /> : null}
                            {this.props.currentValue}{' '}
                            <FontAwesomeIcon icon={faTimes} />
                        </Button>
                    ) : null}
                </ButtonGroup>
                {this.state.error ? (
                    <Alert severity={'warning'}>
                        &nbsp; {this.props.kedo.t('Something went wrong')}{' '}
                        <Button
                            sx={{ float: 'right', marginTop: '-8px' }}
                            color={'warning'}
                            onClick={() => this.fetchItems(false)}
                            disabled={this.props.disabled}
                        >
                            <FontAwesomeIcon icon={faSyncAlt} />
                            &nbsp; {this.props.kedo.t('Retry')}
                        </Button>
                    </Alert>
                ) : null}
                {!this.props.currentValue ? (
                    <List>
                        {this.state.searchName ? this.renderSearch() : null}
                        {this.state.loading ? (
                            <ListItem>
                                <LoadingDefault />
                            </ListItem>
                        ) : null}
                        {this.state.items.map((item) => (
                            <ListItemButton
                                key={item.id}
                                onClick={() => {
                                    this.props.onSelect(item)
                                    this.updateCurrentItem(item.id)
                                }}
                                disabled={this.props.disabled}
                            >
                                {this.getDisplayName(item)}
                            </ListItemButton>
                        ))}
                        {this.renderLoadMoreAndFooter()}
                    </List>
                ) : null}
            </div>
        )
    }
}
